import { render, staticRenderFns } from "./BeautifulNumber.vue?vue&type=template&id=78beed59&scoped=true"
import script from "./BeautifulNumber.vue?vue&type=script&lang=js"
export * from "./BeautifulNumber.vue?vue&type=script&lang=js"
import style0 from "./BeautifulNumber.vue?vue&type=style&index=0&id=78beed59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78beed59",
  null
  
)

export default component.exports